export default __webpack_public_path__ + "static/media/tickets.836d487e.png";